class MegaMenuFlyout extends HTMLElement {
  constructor() {
    super();

    this.activeClass = 'is-active';
    this.parents = Array.from(this.querySelectorAll('.mega-menu-flyout__parent'));
    this.panels = Array.from(this.querySelectorAll('.mega-menu-flyout__panel'));
    this.openFirst = this.dataset.openFirst === 'true';
    this.isTouch = window.matchMedia('(hover: none)').matches;

    this.onParentEnter = this.handleParentEnter.bind(this);
    this.onParentClick = this.handleParentClick.bind(this);
  }

  connectedCallback() {
    this.parents.forEach((parent) => {
      parent.addEventListener('mouseenter', this.onParentEnter);
      parent.addEventListener('focusin', this.onParentEnter);
      parent.addEventListener('click', this.onParentClick);
    });

    this.megaMenu = this.closest('mega-menu');
    if (this.megaMenu) {
      this.onMenuLeave = this.reset.bind(this);
      this.megaMenu.addEventListener('mouseleave', this.onMenuLeave);
    }

    this.reset();
  }

  disconnectedCallback() {
    this.parents.forEach((parent) => {
      parent.removeEventListener('mouseenter', this.onParentEnter);
      parent.removeEventListener('focusin', this.onParentEnter);
      parent.removeEventListener('click', this.onParentClick);
    });

    if (this.megaMenu && this.onMenuLeave) {
      this.megaMenu.removeEventListener('mouseleave', this.onMenuLeave);
    }
  }

  handleParentEnter(event) {
    this.open(event.currentTarget.dataset.panel);
  }

  /* On touch devices the first tap opens the panel, the second one follows the link. */
  handleParentClick(event) {
    if (!this.isTouch) return;

    const parent = event.currentTarget;
    const panelId = parent.dataset.panel;
    if (!panelId) return;

    if (parent.getAttribute('aria-expanded') !== 'true') {
      event.preventDefault();
      this.open(panelId);
    }
  }

  open(panelId) {
    this.parents.forEach((parent) => {
      if (!parent.dataset.panel) return;
      parent.setAttribute('aria-expanded', parent.dataset.panel === panelId ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle(this.activeClass, panel.id === panelId);
    });

    /* Panels have real height, so switching one changes how tall the dropdown is. */
    this.dispatchEvent(new CustomEvent('mega-menu:panel-change', { bubbles: true }));
  }

  reset() {
    if (this.openFirst) {
      const firstParent = this.parents.find((parent) => parent.dataset.panel);
      if (firstParent) {
        this.open(firstParent.dataset.panel);
        return;
      }
    }

    this.open(null);
  }
}

customElements.define('mega-menu-flyout', MegaMenuFlyout);
